import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";
import { fetchMyDepragApi } from "../../../../../../../Infrastructure/Api/ApiBaseCall";
import { DefaultResponse } from "../../../../../../../Infrastructure/Api/Model/DefaultResponse";
import { useAppDispatch, useAppSelector } from "../../../../../../../Infrastructure/Store/hooks";
import { RootState, store } from "../../../../../../../Infrastructure/Store/store";
import { setDeleteTitleAndIdWhatsNew, toggleDeletePopupWhatsNew } from "../../../Store/WhatsNewSlice";
import { LanguageConsumer } from "../../../../../../../Infrastructure/Internationalisation/TranslationService";

export const WhatsNewDelete = () => {
    const dispatch = useAppDispatch();
    const { deletePopupVisible, deleteId, deleteTitle} = useAppSelector(store => store.whatsNew);    

    const closeModal = () => {
        dispatch(setDeleteTitleAndIdWhatsNew({title: "", id: 0}));
        dispatch(toggleDeletePopupWhatsNew());
    }

    const deleteHelp = async () => {
        await fetchMyDepragApi<DefaultResponse>(null, `highlevel/whatsnew/delete/${deleteId}`, 'DELETE', dispatch, store.getState() as RootState, "SuccessfullyDeletedWhatsNew");
    }

    return(
        <LanguageConsumer>
            {({getTranslatedText}) =>
            <>
                <Dialog
                    open={deletePopupVisible}
                    onClose={closeModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {getTranslatedText("AreYouSure")}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <Typography><span dangerouslySetInnerHTML={{ __html: getTranslatedText("DoYouReallyWantToDeleteWhatsNew", [deleteTitle]) }}></span></Typography>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" color="darky" onClick={closeModal}>{getTranslatedText("CommonCancel")}</Button>
                        <Button variant="outlined" color="error" onClick={async () => {
                            await deleteHelp();
                            closeModal();
                        }} autoFocus>{getTranslatedText("DeleteWhatsNew")}</Button>
                    </DialogActions>
                </Dialog>
            </>
            }
        </LanguageConsumer>
    )
}